import type { Kmat } from "~/Configurators/Linear/models";
import { isNonNull } from "~/utils/reducers";

export function pushStandardValueIfMissing(kmat: Kmat, csticName: string, value: string) {
  const cstic = kmat.cstics[csticName];
  if (cstic) {
    const standardValue = cstic.values.find((item) => item.key == value);
    if (!standardValue) {
      cstic.values.push({
        key: value,
        value: value,
        standard: true,
        label: "",
        info: "",
        imageUrl: "",
      });
    }
  }
}

export function getCsticsValue(mainKmat: Kmat, ...cstics: string[]) {
  return cstics.map((cstic) => mainKmat.cstics[cstic]?.value ?? "");
}

export function getCsticNumericValue(mainKmat: Kmat, cstic: string, defaultValue = 0): number {
  return Number(mainKmat.cstics[cstic]?.value ?? defaultValue);
}

export function getCsticPossibleValues(mainKmat: Kmat, cstic: string) {
  return (mainKmat.cstics[cstic]?.values ?? []).map((v) => v.value);
}

export function csticHasValue(mainKmat: Kmat, cstic: string) {
  const val = mainKmat.cstics[cstic]?.value;
  return val !== null && val !== undefined && val !== "";
}

export function csticsHaveValue(mainKmat: Kmat, ...cstics: string[]) {
  return cstics.every((cstic) => csticHasValue(mainKmat, cstic));
}

export function join(separator: string, ...values: string[]) {
  return values.filter(isNonNull).join(separator);
}
